import { render, staticRenderFns } from "./CardPersonalWork.vue?vue&type=template&id=661683ac"
import script from "./CardPersonalWork.vue?vue&type=script&lang=js"
export * from "./CardPersonalWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661683ac')) {
      api.createRecord('661683ac', component.options)
    } else {
      api.reload('661683ac', component.options)
    }
    module.hot.accept("./CardPersonalWork.vue?vue&type=template&id=661683ac", function () {
      api.rerender('661683ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo/CardPersonalWork.vue"
export default component.exports